import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail7 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            認識8個Java當中的原始資料型態，以及每種資料型態的使用時機與語法
          </li>
          <li>使用Java內建的String、Array、ArrayList等物件</li>
          <li>
            認識物件導向的三大要素：Polymorphism(多型), Inheritance(繼承),
            Encapsulation(封裝)
          </li>
          <li>
            學習Abstract Class以及Interface，以及使用KeyListener與MouseListener
          </li>
          <li>
            了解NullPointerException、Concurrent Modification Exception
            問題處理流程與方法
          </li>
          <li>製作Java遊戲，並且在多個作業系統執行</li>
          <li>使用Java連結MySQL資料庫，並學習如何架設資料庫</li>
          <li>在Java當中預防SQL Injection攻擊資料庫</li>
          <li>了解HTTP網路基本概念，學習Java Servlet網頁開發</li>
          <li>
            使用多線程Java編寫（Multi-threading Programming），提高運算速度
          </li>
          <li>使用Socket語法資料傳輸，傳送基本數據、進階數據、文件資料</li>
          <li>使用Java Swing 製作貪食蛇遊戲</li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>想學習Java開發的學生、或是轉職者</li>
          <li>想學習用SpringBoot製作網頁的網頁開發者</li>
          <li>想做Android手機app程式者</li>
          <li>想要轉職成為工程師的在職者</li>
          <li>桌面的應用程式、伺服器、設備等開發應用有興趣者</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail7;
